import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TableColumnsType, Select, Table } from 'antd';
import { IEvaluationItemTree } from '../../../models/evaluationItem.model';
import Button from '../../Button';
import { ISemesterLessonPlan } from '../../../models/semesterLessonPlan2.model';
import { ISemesterEvaluationHW } from '../../../models/semesterEvaluation.model';

interface IProps {
  semesterLessonPlans: ISemesterLessonPlan[];
  evaluationItemTree: IEvaluationItemTree[];
  semesterEvaluationsHW: ISemesterEvaluationHW[];

  onRowClick(lessonPlanCode: number): void;

  onSubmit(record: ISemesterEvaluationHW): void;

  onDelete(value: number): void;
}

const { Option } = Select;

const EvaluationHWTable: FC<IProps> = ({
  semesterLessonPlans,
  evaluationItemTree,
  semesterEvaluationsHW,
  onRowClick,
  onSubmit,
  onDelete,
}) => {
  const { t } = useTranslation();
  const [lessonPlanCode, setLessonPlanCode] = useState<number>();
  const [tableSemesterEvaluationHW, setTableSemesterEvaluationHW] = useState<
    ISemesterEvaluationHW[]
  >([]);

  useEffect(() => {
    setTableSemesterEvaluationHW([
      ...semesterEvaluationsHW,
      {
        evaluationItemCode: 0,
        evaluationCode: 0,
      },
    ]);
  }, [semesterEvaluationsHW]);

  const onEvaluationItemCodesChange = (value: number, index: number) => {
    const newTableActivityItemsHW = [...tableSemesterEvaluationHW];
    newTableActivityItemsHW[index].evaluationItemCode = value;
    setTableSemesterEvaluationHW(newTableActivityItemsHW);
  };

  const onLocalDelete = (value: number, index: number) => {
    if (value === 0) {
      setTableSemesterEvaluationHW(
        tableSemesterEvaluationHW.filter((_, index2) => index !== index2),
      );
    } else {
      onDelete(value);
    }
  };

  const columns: TableColumnsType<ISemesterEvaluationHW> = [
    {
      title: 'Activity',
      key: 'evaluationItemCode',
      dataIndex: 'evaluationItemCode',
      render: (value: number | null, _, index) => (
        <Select
          defaultValue={value}
          value={tableSemesterEvaluationHW[index].evaluationItemCode}
          onChange={(value) => onEvaluationItemCodesChange(value, index)}
          style={{ width: '100%' }}
        >
          <Option value={0}>{t('common.button.select')}</Option>
          {evaluationItemTree.map(
            ({ evaluationItemCode, evaluationItemName }) => (
              <Option value={evaluationItemCode}>{evaluationItemName}</Option>
            ),
          )}
        </Select>
      ),
    },
    {
      title: t('common.button.save'),
      key: 'semesterSeqEvaluationCode',
      dataIndex: 'semesterSeqEvaluationCode',
      render: (value, record) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            className="btn-basic small pink"
            onClick={() => onSubmit(record)}
            text={t('common.button.save')}
          />
        </div>
      ),
    },
    {
      title: t('common.button.delete'),
      key: 'evaluationCode',
      dataIndex: 'evaluationCode',
      render: (value: number, _, index) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            className="btn-basic small gray"
            onClick={() => onLocalDelete(value, index)}
            text={t('common.button.delete')}
          />
        </div>
      ),
    },
  ];

  const onRowAdd = () => {
    const newTableActivityItemsHW = [...tableSemesterEvaluationHW];
    newTableActivityItemsHW.push({
      evaluationItemCode: 0,
      evaluationCode: 0,
    });
    setTableSemesterEvaluationHW(newTableActivityItemsHW);
  };

  return (
    <>
    <div className="comm-bx__space">
      <div className="comm-btn__area right">
        <Button
          className="btn-basic pink-line"
          text={t('program.semester.button6')}
          onClick={onRowAdd}
        />
      </div>
    </div>
    <div className="flex">
      <div className="col-4">
        <div className="comm-table__area mt-0 pl-0 pr-0">
          <table>
            <colgroup>
              <col width="50%" />
              <col width="50%" />
            </colgroup>
            <thead>
              <tr>
                <th className="text-center">{t('program.semester.4')}</th>
                <th className="text-center">Lesson</th>
              </tr>
            </thead>
            <tbody>
              {semesterLessonPlans.map(
                (item: ISemesterLessonPlan, index: number) => (
                  <tr
                    key={index}
                    className={
                      lessonPlanCode === item.lessonPlanCode
                        ? ' chosen'
                        : 'pointer'
                    }
                    onClick={() => {
                      onRowClick(item.lessonPlanCode);
                      setLessonPlanCode(item.lessonPlanCode);
                    }}
                  >
                    <td className="text-center">{item.subjectSeq}</td>
                    <td className="text-center">{item.lessonName}</td>
                  </tr>
                ),
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-8 pr-0">
        <Table
          className='comm-table__area mt-0'
          columns={columns}
          dataSource={tableSemesterEvaluationHW}
          pagination={false}
        />
      </div>
    </div>
    </>
  );
};

export default EvaluationHWTable;
